<script>
import AppBlock from '@components/apps/app-block.vue'
import AppTag from '@components/apps/app-tag.vue'

export default {
  components: { AppTag, AppBlock },
  props: {
    app: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <div :class="$style.appBlockContainerWithTag">
    <AppBlock
      :name="app.appName"
      :description="app.description"
      :category="app.category"
      :card-image="app.cardImage"
      :card-image-mobile="app.cardImageMobile"
      :app-url="app.appUrl"
      :app-id="app.appId"
      :class="$style.appBlock"
      :is-new-app="app.isNewApp"
      :options="{ forceMobileDesign: true }" />
    <AppTag :app="app" :category="app.category" :class="$style.appTag" />
  </div>
</template>

<style lang="scss" module>
@import '@design';

.appTag {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 22px;
  padding: 2px 16px;
  color: $white;
  border: 1px solid $white;
  border-radius: 50px;
}

.appBlockContainerWithTag {
  max-width: 98px;
}
</style>
